/**
 * @generated SignedSource<<1075e02ea7e47f2c700ebc1f8e0f87b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StartTreeConfigType = "StartTree_CMECertifiedNeedsSpecificGlobalUserStatus" | "StartTree_CanNot" | "StartTree_SpecificUserRolesCan" | "StartTree_SpecificUserStatusesCan" | "%future added value";
export type UserRoles = "AlliedHealthProfessionals" | "Apothecary" | "Dentist" | "Doccheck" | "Doctor" | "Midwife" | "Other" | "PKA" | "PTA" | "PharmaceuticalEngineer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment$data = {
  readonly configType?: StartTreeConfigType;
  readonly id?: string;
  readonly userRoles?: ReadonlyArray<UserRoles>;
  readonly " $fragmentType": "SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment";
};
export type SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment$key = {
  readonly " $data"?: SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userRoles",
          "storageKey": null
        }
      ],
      "type": "SpecifiedUserRolesCanStartTreeConfig",
      "abstractKey": null
    }
  ],
  "type": "StartTreeConfig",
  "abstractKey": "__isStartTreeConfig"
};

(node as any).hash = "f4beab8ce0727e8f8c16554d3f4bef5b";

export default node;
